import React from "react";

const ChevronLeftShape: React.FC = () => (
<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="40" height="40" rx="9.5" stroke="white"/>
<path d="M24.3281 13L15.9948 20.5L24.3281 28" stroke="white" strokeLinecap="round"/>
</svg>
);

export default ChevronLeftShape;
